import {ChangeDetectorRef, Component, forwardRef, Input, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUITextControlComponent),
            multi: true
        }
    ],
    selector: "fui-text-control",
    templateUrl: "./text-control.component.html",
    standalone: false
})
export class FUITextControlComponent extends FUIAbstractControl {
    /**
     * Indicates if the text control can be removed when in pill mode
     */
    @Input() public removable: boolean = true;

    /**
     * Allows the control to be actually readonly, as opposed to the readOnly input, which makes it disabled
     */
    @Input() public modifiable: boolean = true;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
